import { MoreVert } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMoreVert12Line = createIcon(MoreVert, 12, "Line");
export const IconMoreVert16Line = createIcon(MoreVert, 16, "Line");
export const IconMoreVert20Line = createIcon(MoreVert, 20, "Line");
export const IconMoreVert24Line = createIcon(MoreVert, 24, "Line");
export const IconMoreVert32Line = createIcon(MoreVert, 32, "Line");
export const IconMoreVert48Line = createIcon(MoreVert, 48, "Line");
export const IconMoreVert64Line = createIcon(MoreVert, 64, "Line");
